import { teamTypes, socketTypes, generalTypes } from '../actions'
import { Auth } from '../helpers'

const initialState = {
  myTeam: {},
  teams: []
}

const team = (state = initialState, action) => {
  switch (action.type) {
    case generalTypes.GET_INIT_DATA:
      return initialState
    case teamTypes.REG_SUCCESS:
      let teams = state.teams.slice(0)
      teams.push(action.team)
      return {
        ...state,
        teams
      }
    case teamTypes.SAVE_MINE:
      if (action.payload) {
        action = action.payload
      }
      let newTeam = (action.team && action.team.participants && action.team.participants.indexOf(Auth.getParticipant()) > -1)
        ? action.team : {}
      if (newTeam.name === 'Adidas Team' || newTeam.name === 'FidWeb') {
        Auth.setAdmin()
      }
      return {
        ...state,
        myTeam: newTeam
      }
    case teamTypes.SAVE_TEAMS:
      return {
        ...state,
        teams: action.teams || []
      }
    case teamTypes.UPDATE:
      teams = state.teams.slice(0)
      let index = teams.findIndex(t => t.id === action.team.id)
      index > -1 && (teams[index] = action.team)
      index === -1 && teams.push(action.team)
      return {
        ...state,
        teams
      }
    case teamTypes.REMOVE:
      teams = state.teams.slice(0)
      teams = teams.filter(t => t.id !== action.id)
      return {
        ...state,
        teams
      }
    case socketTypes.REMOVED_FROM_TEAM:
      return {
        ...state,
        myTeam: {}
      }
    default: return state
  }
}

export default team



// WEBPACK FOOTER //
// ./src/reducers/team.js